import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/PrimaryBox';
import DangerBox from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/DangerBox';
import MqttTableBroker from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/MqttTableBroker';
import MqttTableClient from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/MqttTableClient';
import TimeLine from 'components/Products/CommentList/MqttUpdatesList';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  PrimaryBox,
  DangerBox,
  MqttTableBroker,
  MqttTableClient,
  TimeLine,
  BreadCrumbs,
  SEOHelmet,
  React
};